import React from 'react'
import { useSelector } from 'react-redux'
import { ListItem, ListItemButton, Tooltip } from '@mui/material'
import { ListItemIcon, ListItemText } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const ListItemDLM = ({
  keyText,
  primary,
  secundary,
  iconType,
  children,
  simple = false,
  onClick,
  sx,
}) => {
  const theme = useTheme()
  const _open = useSelector(state => state.drawerLeft.open)
  const widthMinDrawer = useSelector(state => state.drawerLeft.drawerWidthMin)

  const stylePrimaryText = {
    color: theme.palette.text.primary,
    fontFamily: theme.typography.fontFamily,
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '0.85em',
    lineHeight: '1em',
  }

  return (
    <ListItem
      key={keyText}
      disablePadding
      sx={{ display: 'block', width: !_open ? widthMinDrawer : 'none', ...sx }}>
      {simple ? (
        <Tooltip title={!_open ? primary : ''} placement="left">
          <ListItemButton
            onClick={onClick}
            sx={{
              minHeight: '6vh',
              justifyContent: _open ? 'initial' : 'center',
              px: 1.6,
              '&:hover': {
                backgroundColor: '#0d213a26',
              },
            }}>
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: _open ? 1.5 : 'auto',
                justifyContent: 'center',
              }}>
              {iconType}
            </ListItemIcon>
            <ListItemText
              primary={primary}
              primaryTypographyProps={stylePrimaryText}
              secondary={secundary}
              sx={{ display: _open ? 'inline' : 'none' }}
            />
          </ListItemButton>
        </Tooltip>
      ) : (
        children
      )}
    </ListItem>
  )
}
export default ListItemDLM
